import React from "react";
import Slider from "react-slick";

export class SponsorsScroller extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      sponsors: this.props.sponsors,
      slides: this.props.slides,
      logos: []
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({sponsors: newProps.sponsors, slides: newProps.slides});
  }
  
  render() {
    var settings = {
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      slidesToShow: this.state.slides,
      slidesToScroll: 1,
      swipeToSlide: false,
    };
    return (
      <Slider {...settings}>
        {this.state.sponsors.map((sponsor) => (
      <div className='SponsorBox' key={this.state.sponsors.indexOf(sponsor)}>
        <div style={{
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50% 50%',
          width: 100,
          height: 100,
          backgroundImage: 'url(' +  sponsor  + ')'
        }} />
      </div>
        ))}
      </Slider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SponsorsScroller.js